import { Grid, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { checkIsRole } from "app/common/LocalFunction";
import AllServicesIndex from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/AllServicesTab/AllServicesIndex";
import CustomerJourneyTabIndex from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/CustomerJourneyTab/CustomerJourneyTabIndex";
import FeeIndex from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/FeeTab/FeeIndex";
import DebtFeeDetailPopup from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/FeeTab/Popup/DebtFeeDetailPopup";
import RegisterProductAndMedicalIndex from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/RegisterProductTab/RegisterProductAndMedicalIndex";
import UncompletedServicePopup from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/TreatmentTab/Popup/UncompletedServicePopup";
import TreatmentIndex from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/TreatmentTab/TreatmentIndex";
import CheckOutPopup from "app/PatientManagement/PatientList/Popup/CheckOutPopup";
import { useStore } from "app/stores";
import { observer } from "mobx-react";
import { memo, useEffect } from "react";
import ImageTreatmentTabIndex from "./ImageTreatmentTab/ImageTreatmentTabIndex";
import TreamentGeneralInfo from "./TreamentGeneralInfo";
import TreamentInfoPatient from "./TreamentInfoPatient/TreamentInfoPatient";

export const TAB_LIST_TREAMENTS = [
  {
    tabName: "Thông tin khách hàng",
    content: (
      <>
        <TreamentGeneralInfo />
      </>
    ),
    value: 1,
  },
  {
    tabName: "Điều trị",
    content: (
      <>
        {/* componet này là đang dùng chung với bên quản lý khách hàng  */}
        <TreatmentIndex />

        {/* Còn componnent này hiện tại ko dùng vẫn còn file  */}
        {/* <TreatmentTabIndex /> */}
      </>
    ),
    value: 2,
  },
  {
    tabName: "Tất cả ảnh",
    content: (
      <>
        <ImageTreatmentTabIndex />
      </>
    ),
    value: 3,
  },
  {
    tabName: "Hành trình khách hàng",
    content: (
      <>
        <CustomerJourneyTabIndex />
      </>
    ),
    value: 4,
  },
  {
    tabName: "Sản Phẩm",
    content: (
      <>
        <RegisterProductAndMedicalIndex />
      </>
    ),
    value: 5,
  },
  {
    tabName: "Thanh toán",
    content: (
      <>
        <FeeIndex />
      </>
    ),
    value: 6,
  },
  {
    tabName: "Tất cả DV",
    content: (
      <>
        <AllServicesIndex />
      </>
    ),
    value: 7,
  },
];
const TreamentInfoDetailIndex = () => {
  const {
    handleGetPatientOverviewById,
    initialPatient,
    setCurrentTab,
    currentTab,
    openInvoiceDebtFeePopup,
    handleCloseInvoiceDebtFeePopup,
    dataInvoiceDebtFee,
  } = useStore().patientManagementStore.patientGeneralStore;
  const {
    openUncompletedServicePopup,
    handleConfirmAssignService,
    handleOpenUncompletedServicePopup,
    resetStore: resetUncompletedRegisterServiceStore,
    handleCloseUncompletedServicePopup,
    searchRegisterService,
    handleOpenConfirmAssign,
    handleChangeFormSearchUncompletedService,
    handleChangeFormSearchService,
    handleCloseConfirmAssign,
  } = useStore().patientManagementStore.uncompletedRegisterServiceStore;
  const {
    pagingServiceRequestItemByPatientServiceRegisterInfo,
    handleSetSearchObject,
    searchObject,
  } = useStore().patientManagementStore.serviceRequestItemStore;

  const {
    openFormCheckOut,
    handleCloseFormCheckOut,

    initialCheckOut,
    checkOutPatient,
  } = useStore().patientManagementStore.patientListStore;
  async function handleConfirmAssignAndRenewPage() {
    try {
      await handleConfirmAssignService();
      const newSO = {
        ...searchObject,
        orderDateTo: new Date(),
      };
      handleSetSearchObject(newSO);
      await pagingServiceRequestItemByPatientServiceRegisterInfo();
    } catch (error) {
      console.error(error);
    }
  }
  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  useEffect(() => {
    if (patientId) {
      handleGetPatientOverviewById(patientId);
    }
  }, [patientId]);

  return (
    <>
      <Grid container spacing={1} className="reception-patient relative">
        <TreamentInfoPatient
          patient={initialPatient?.patientInfo}
          patientId={patientId}
          initialPatient={initialPatient}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />

        <Grid item md={12} style={{ width: "100%" }}>
          <div className="cards-container">
            <TabComponent
              currentTab={currentTab}
              setCurrentTab={setCurrentTab}
              patientId={patientId}
            />
          </div>
        </Grid>
      </Grid>
      {openUncompletedServicePopup && (
        <UncompletedServicePopup
          open={openUncompletedServicePopup}
          handleClose={handleCloseUncompletedServicePopup}
          initialValue={searchRegisterService}
          onSubmit={handleChangeFormSearchUncompletedService}
          handleChangeFormSearchService={handleChangeFormSearchService}
          handleConfirmAssignAndRenewPage={handleConfirmAssignAndRenewPage}
          handleGetPatientOverviewById={handleGetPatientOverviewById}
          handleOpenConfirmAssign={handleOpenConfirmAssign}
          handleCloseConfirmAssign={handleCloseConfirmAssign}
        />
      )}
      {
        <DebtFeeDetailPopup
          open={openInvoiceDebtFeePopup}
          handleClose={handleCloseInvoiceDebtFeePopup}
          initialValue={dataInvoiceDebtFee}
        />
      }
      {openFormCheckOut && (
        <CheckOutPopup
          open={openFormCheckOut}
          handleClose={handleCloseFormCheckOut}
          handleSubmit={async (values, { setSubmitting }) => {
            let { patient } = values;
            let dataStatus = await checkOutPatient(
              { ...values, patient },
              {
                setSubmitting,
              }
            );
            if (dataStatus !== false) {
              setTimeout(() => {
                handleGetPatientOverviewById(patientId);
              }, 500);
              // getAdvice();
            }
          }}
          initialValues={initialCheckOut}
        />
      )}
    </>
  );
};

const TabComponent = observer(({ currentTab, setCurrentTab, patientId }) => {
  const accessibleTabs = TAB_LIST_TREAMENTS.filter((tab) => {
    if (tab?.role) {
      return tab.role?.some((el) => checkIsRole(el));
    } else {
      return true;
    }
  });
  return (
    <TabContext value={currentTab}>
      <TabList
        className="tabs-container"
        variant="scrollable"
        scrollButtons="on"
        onChange={(_, newTabIndex) => {
          setCurrentTab(newTabIndex);
        }}
        value={currentTab}
      >
        {accessibleTabs.map((tab, index) => (
          <Tab
            key={index}
            className={`item-tabs ${
              index === currentTab ? "item-tabs-active" : ""
            }`}
            label={tab.tabName}
            value={index}
          />
        ))}
      </TabList>
      {accessibleTabs.map((tab, index) => (
        <TabPanel
          component="section"
          className="p-0"
          key={tab.value}
          value={index}
        >
          {tab.content}
        </TabPanel>
      ))}
    </TabContext>
  );
});

export default memo(observer(TreamentInfoDetailIndex));
